document.addEventListener('DOMContentLoaded', function () {
    const searchToggleButton = document.querySelector('.side-header-search-mobile');
    const liveSearchElement = document.querySelector('[data-live-search]');
  
    searchToggleButton.addEventListener('click', function () {
      if (liveSearchElement.style.display === 'none' || liveSearchElement.style.display === '') {
        liveSearchElement.style.display = 'block';
      } else {
        liveSearchElement.style.display = 'none';
      }
    });
  });